export default __webpack_public_path__ + "static/media/new_user_activity_57.f19e9df0.png";